import React from 'react';
import AspectRatio from 'components/AspectRatio';
import * as S from './styles';
import { ThumbnailProps } from './types';

/**
 * A thumbnail component that can enforce a specific aspect ratio
 */
function Thumbnail<As extends React.ElementType = 'div'>(
  props: ThumbnailProps<As>,
) {
  const {
    as,
    alt,
    basis = 'width',
    children,
    className,
    objectFit,
    ratio = 1,
    src,
    style,
    ...restProps
  } = props;

  const Component = as ?? 'div';

  return (
    <S.Root as={Component} className={className} $basis={basis} {...restProps}>
      <AspectRatio {...{ basis, objectFit, ratio }}>
        <img alt={alt} src={src} />
      </AspectRatio>
      {children}
    </S.Root>
  );
}

export default Thumbnail;
